module.exports = __webpack_public_path__ + "static/media/menu-digitale.16e654ba.svg";